import { Action } from '@ngrx/store';
import { WebAngularSharedDataAccessFeatureFlagApisPayload, WebAngularSharedDataAccessFeatureFlagApiChangesPayload } from '../models';

export enum ActionTypes {
  LOAD_FLAGS = '[WebAngularSharedDataAccessFeatureFlagApi] LOAD FLAGS',
  LOAD_FLAGS_FROM_CONFIG = '[WebAngularSharedDataAccessFeatureFlagApi] LOAD FLAGS FROM CONFIG',
  SET_FLAGS = '[WebAngularSharedDataAccessFeatureFlagApi] SET FLAGS',
  UPDATE_FLAGS = '[WebAngularSharedDataAccessFeatureFlagApi] UPDATE FLAGS',
  INITIALIZATION_COMPLETE = '[WebAngularSharedDataAccessFeatureFlagApi] INITIALIZATION_COMPLETE',
}

export class LoadFlags implements Action {
  readonly type = ActionTypes.LOAD_FLAGS;
  constructor() {}
}

export class LoadFlagsFromConfig implements Action {
  readonly type = ActionTypes.LOAD_FLAGS_FROM_CONFIG;
  constructor(public payload: WebAngularSharedDataAccessFeatureFlagApisPayload) {}
}

export class SetFlags implements Action {
  readonly type = ActionTypes.SET_FLAGS;
  constructor(public payload: WebAngularSharedDataAccessFeatureFlagApisPayload) {}
}

export class UpdateFlags implements Action {
  readonly type = ActionTypes.UPDATE_FLAGS;
  constructor(public payload: WebAngularSharedDataAccessFeatureFlagApiChangesPayload) {}
}

export class InitalizationCompleteAction implements Action {
  readonly type = ActionTypes.INITIALIZATION_COMPLETE;
  constructor(public payload: boolean) {}
}

export type All = LoadFlags | SetFlags | UpdateFlags | LoadFlagsFromConfig | InitalizationCompleteAction;
